/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useMemo, useSyncExternalStore } from 'react';
export function useVuex(store, selector = (state) => state) {
    const getSnapshot = () => selector(store.state);
    const subscribe = (callback) => {
        const unsubscribe = store.subscribe(() => {
            callback();
        });
        return unsubscribe;
    };
    // Use React's useSyncExternalStore to sync with Vuex
    const state = useSyncExternalStore(subscribe, getSnapshot);
    // Provide access to Vuex store methods
    const dispatch = (type, payload) => store.dispatch(type, payload);
    const commit = (type, payload) => store.commit(type, payload);
    // Create a reactive wrapper for getters
    const getters = {};
    Object.keys(store.getters).forEach((key) => {
        Object.defineProperty(getters, key, {
            get: () => store.getters[key],
            enumerable: true,
        });
    });
    const castedStore = store;
    const actions = useMemo(() => {
        return Object.fromEntries(Object.entries(castedStore._actions).map(([k, v]) => [k, v[0]]));
    }, [castedStore._actions]);
    const mutations = useMemo(() => {
        return Object.fromEntries(Object.entries(castedStore._mutations).map(([k, v]) => [k, v[0]]));
    }, [castedStore._mutations]);
    return {
        state,
        dispatch,
        commit,
        getters,
        actions,
        mutations,
    };
}
